import { getWindow } from 'src/utilities/window';

export interface ITypeaheadStyle {
  maxHeight: string;
  overflow: string;
}

export function getTypeaheadStyle(target: HTMLElement): ITypeaheadStyle {
  const window = getWindow();
  const MIN_TYPEAHEAD_HEIGHT = 300;
  const MIN_PADDING_BOTTOM = 10;
  if (!target || typeof target.getBoundingClientRect !== 'function') {
    return null;
  }

  const rect = target.getBoundingClientRect();

  if (
    !rect ||
    !rect.bottom ||
    rect.bottom < 0 ||
    rect.bottom > window.outerHeight
  ) {
    return null;
  }
  let maxHeight: number;
  if (window.innerHeight - rect.bottom < MIN_TYPEAHEAD_HEIGHT) {
    maxHeight = MIN_TYPEAHEAD_HEIGHT;
  } else {
    maxHeight = window.innerHeight - rect.bottom - MIN_PADDING_BOTTOM;
  }

  return {
    maxHeight: `${maxHeight}px`,
    overflow: 'auto',
  };
}
